export type {
  TResPrograms,
  ContentPartType,
  ContentSubPartType
} from './getFullProgramContentsData'
export { getFullProgramContentsData } from './getFullProgramContentsData'
